module.exports = __webpack_public_path__ + "static/media/palmtree.ef1ebefa.svg";